let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8f19I")).then(() => parcelRequire('bVxF3'));